import React, { Component } from 'react';
import {  Redirect } from 'react-router-dom';
import BACKEND_URL from '../../config';

class NewReview extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      employee_id: '',
      comments: '',
      wins: '',
      opportunities: '',
      feedback: '',
      requires_feedback: 0,
      reviewer_id: '',
      redirectAdmin: false,
      employees: []
    };
  }
  componentDidMount() {
    fetch(`${BACKEND_URL}/employees`)
      .then(res => res.json())
      .then(employees => {
        return this.setState({ employees: employees });
      });
        
  } 
  handleSubmit = (event) => {
    event.preventDefault();
    const data = {
      ...this.state,
      created_date: Date.now()
    };
    console.log(JSON.stringify(data));
    fetch(`${BACKEND_URL}/reviews`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
      .then(function(response) {
        if (response.status >= 400) {
          throw new Error('Bad response from server');
        }
        return response.json();
      })
      .then((data) => {
        if (data) {
          this.setState({ redirectAdmin: true });
        }
      })
      .catch(function(err) {
        console.log(err);
      });
  }

  logChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }
  logChangeCheckbox = (e) => {
    this.setState({ [e.target.name]: (e.target.checked ? 1 : 0) });
  }

  getEmployeesOptions = () => this.state.employees.map(employee => (
    <option value={employee.id} key={employee.id}>{employee.first_name} {employee.last_name}</option>
))

  render = () => {
    if (this.state.redirectAdmin) {
      return <Redirect to='/' />;
    }

    return (
      <main className='pa4 black-80'>
        <form
          className='measure center'
          onSubmit={this.handleSubmit}
          method='POST'
        >
          <fieldset id='sign_up' className='ba b--transparent ph0 mh0'>
            <legend className='f4 fw6 ph0 mh0'>New Review</legend>
            <div className='mt3'>
              <label className='db fw6 lh-copy f6' htmlFor='employee_id'>
                Employee
              </label>
              <select id='employee_id' name='employee_id' value={this.state.employee_id} onChange={this.logChange}>
                { this.getEmployeesOptions() }
              </select>
            </div>
            <div className='mt3'>
              <label className='db fw6 lh-copy f6' htmlFor='comments'>
                Comments
              </label>
              <textarea
                className='pa2 input-reset ba bg-transparent hover-bg-black-10 hover-dark-gray w-100'
                type='text'
                name='comments'
                id='comments'
                rows='5'
                columns='50'
                value={this.state.comments}
                onChange={this.logChange}
              />
            </div>
            <div className='mt3'>
              <label className='db fw6 lh-copy f6' htmlFor='wins'>
                Wins
              </label>
              <textarea
                className='pa2 input-reset ba bg-transparent hover-bg-black-10 hover-dark-gray w-100'
                name='wins'
                id='wins'
                rows='5'
                columns='50'
                value={this.state.wins}
                onChange={this.logChange}
              />
            </div>
            <div className='mt3'>
              <label className='db fw6 lh-copy f6' htmlFor='opportunities'>
                Opportunities
              </label>
              <textarea
                className='pa2 input-reset ba bg-transparent hover-bg-black-10 hover-dark-gray w-100'
                name='opportunities'
                id='opportunities'
                rows='5'
                columns='50'
                value={this.state.opportunities}
                onChange={this.logChange}
              />
            </div>
            <div className='mt3'>
              <label className='db fw6 lh-copy f6' htmlFor='requires_feedback'>
                Requires feedback
              </label>
              <input
                className='mr2'
                type='checkbox'
                name='requires_feedback'
                id='requires_feedback'
                value={this.state.requires_feedback}
                checked={this.state.requires_feedback}
                onChange={this.logChangeCheckbox}
              />
            </div>
            <section className={this.state.requires_feedback ? '': 'dn'}>
                <div className='mt3'>
                <label className='db fw6 lh-copy f6' htmlFor='reviewer_id'>
                    Reviewer
                </label>
                <select id='reviewer_id' name='reviewer_id' value={this.state.reviewer_id} onChange={this.logChange}>
                    { this.getEmployeesOptions() }
                </select>
                </div>
                <div className='mt3'>
                <label className='db fw6 lh-copy f6' htmlFor='feedback'>
                    Feedback
                </label>
                <textarea
                    className='pa2 input-reset ba bg-transparent hover-bg-black-10 hover-dark-gray w-100'
                    name='feedback'
                    id='feedback'
                    rows='5'
                    columns='50'
                    value={this.state.feedback}
                    onChange={this.logChange}
                />
                </div>
            </section>
          </fieldset>
          <div className=''>
            <input
              className='b ph3 pv2 input-reset ba b--black bg-transparent grow pointer f6 dib'
              type='submit'
              value='Create'
            />
          </div>
        </form>
      </main>
    );
  }
}

export default NewReview;



// WEBPACK FOOTER //
// ./src/components/review/NewReview.js